export const isFotoInicio = (nsmp) => nsmp.fotoInicio != null && nsmp.fotoInicio;

export const isFotoFim = (nsmp) => nsmp.fotoFim != null && nsmp.fotoFim;

export const isAnaliseRisco = (nsmp) => nsmp.analiseRisco != null && nsmp.analiseRisco;

export const isFotoRegistro = (nsmp) => nsmp.fotoRegistro != null && nsmp.fotoRegistro;

export const isAnexoNsmp = (nsmp) =>
  isFotoInicio(nsmp) || isFotoFim(nsmp) || isAnaliseRisco(nsmp) || isFotoRegistro(nsmp);

export const isFotoRow = (nsmp) =>
  isFotoInicio(nsmp) || isFotoFim(nsmp) || isFotoRegistro(nsmp);

export const isServiceRow = (nsmp) =>
  !isFotoInicio(nsmp) && !isFotoFim(nsmp) && !isAnaliseRisco(nsmp) && !isFotoRegistro(nsmp);

export const isAnaliseRiscoOrFotoRegistro = (nsmp) =>
  isAnaliseRisco(nsmp) || isFotoRegistro(nsmp);

export const isUsoMutuoServiceRow = (nsmp) => !isAnaliseRiscoOrFotoRegistro(nsmp);
